module.exports = __webpack_public_path__ + "img/tu2.9ce44a2d.png";